import da from './da';
import de from './de';
import enGB from './en-GB';
import enUS from './en-US';
import esCO from './es-CO';
import etEE from './et-EE';
import fiFI from './fi-FI';
import frFR from './fr-FR';
import hrHR from './hr-HR';
import itIT from './it-IT';
import ltLT from './lt-LT';
import nlNL from './nl-NL';
import noNO from './no-NO';
import plPL from './pl-PL';
import pt from './pt';
import ruRU from './ru-RU';
import svSE from './sv-SE';
import uk from './uk';
import roRO from './ro-RO';
import bgBG from './bg-BG';

export default {
  de,
  'en-US': enUS,
  'en-GB': enGB,
  'es-CO': esCO,
  'et-EE': etEE,
  'fr-FR': frFR,
  pt,
  da,
  'it-IT': itIT,
  'lt-LT': ltLT,
  'nl-NL': nlNL,
  'no-NO': noNO,
  'pl-PL': plPL,
  'sv-SE': svSE,
  'ru-RU': ruRU,
  'hr-HR': hrHR,
  'fi-FI': fiFI,
  uk: uk,
  'ro-RO': roRO,
  'bg-BG': bgBG,
};
